import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles.css'
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css'
import OtpInput from "@bachdgvn/vue-otp-input";
 

Vue.component("v-otp-input", OtpInput);
Vue.use(Vuesax, {
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
